<template id="Pagamentos">
  <v-ons-page id="PagamentosPage">
    <v-card class="Card_Contain d-flex justify-center">
      <div class="Card_Titulo">
        <h1>Pagamentos</h1>
      </div>

      <div class="Container_Input" style="margin-top: 60px">
        <v-row>
          <div
            class="no-subscription mb-10"
            v-if="pagamentos.find((item) => item.flAtivo === 1) == null"
          >
            <p>Você não possui nenhuma assinatura ativa.</p>

            <div class="plans">
              <v-card
                v-for="item in planos"
                :key="item.id"
                class="mx-auto py-4"
                max-width="344"
                elevation="2"
              >
                <v-card-title>{{ item.dsNome }}</v-card-title>
                <v-card-text>
                  <p class="text--primary">
                    {{ item.planoPagarme.amount }}
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-btn depressed color="primary" @click="openLink(item)">
                    Assinar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
          <v-simple-table
            v-if="pagamentos.length > 0"
            style="width: 100%; margin: 0 10px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Data Assinatura</th>
                  <th class="text-left">Data Inicio</th>
                  <th class="text-left">Data Expiração</th>
                  <th class="text-left">Plano</th>
                  <th class="text-left">Valor</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Ativo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in pagamentos" :key="item.idAssinatura">
                  <td class="text-left">{{ item.dtCriacao }}</td>
                  <td class="text-left">
                    {{ item.assinaturaPagarme.current_period_start }}
                  </td>
                  <td class="text-left">
                    {{ item.assinaturaPagarme.current_period_end }}
                  </td>
                  <td class="text-left">{{ item.plano.dsNome }}</td>
                  <td class="text-left">
                    {{ item.assinaturaPagarme.plan.amount }}
                  </td>
                  <td class="text-left">{{ item.assinaturaPagarme.status }}</td>
                  <td class="text-left">
                    {{ item.flAtivo == 1 ? "Sim" : "Não" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="no-subscription" v-if="pagamentos.length == 0">
            <p>Você não possui nenhuma assinatura.</p>

            <div class="plans">
              <v-card
                v-for="item in planos"
                :key="item.id"
                class="mx-auto py-4"
                max-width="344"
                elevation="2"
              >
                <v-card-title>{{ item.dsNome }}</v-card-title>
                <v-card-text>
                  <p class="text--primary">
                    {{ item.planoPagarme.amount }}
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-btn depressed color="primary" @click="openLink(item)">
                    Assinar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </v-row>

        <v-row class="d-flex justify-center align-center">
          <v-btn
            v-if="pagamentos.find((item) => item.flAtivo === 1)"
            class="botao"
            @click="openDialog()"
            style="text-transform: none; margin-bottom: 30px"
          >
            Cancelar Assinatura
          </v-btn>
        </v-row>
      </div>
    </v-card>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="text-md-body-1"
          >Voce realmente deseja cancelar sua assinatura?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="cancelSubscription()"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>
  </v-ons-page>
</template>

<style scoped lang="scss">
#PagamentosPage {
  margin-left: 256px;
}
ons-row {
  margin-top: 20px;
}
h2 {
  color: #000;
}
.no-subscription {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  width: 100%;

  > p {
    color: #333;
  }
}
.plans {
  display: flex;
  align-items: center;
  justify-items: center;
  width: 60%;

  > div {
    padding: 20px;
  }

  .v-card__actions {
    display: flex;
    justify-content: center;
  }
}
.box-cancel {
  display: flex;
  justify-content: flex-end;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}
</style>

<script>
import { formatToBRL, formatToDate } from "brazilian-values";

export default {
  name: "pagamentos",
  key: "pagamentos",
  data() {
    return {
      idEstabelecimento: 0,
      dialog: false,
      pagamentos: [],
      planos: [],
    };
  },
  async created() {
    await this.loadSubscription();
    await this.loadPlans();
     
   
  },
  methods: {
    async loadPlans() { 
       const responsePlans = await (
        await fetch(`${this.$menu_payment_uri}/public/plans`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("qrservice_token")}`,
          },
        })
      ).json();
      for (const item of responsePlans.data) {
        item.planoPagarme.amount = formatToBRL(item.planoPagarme.amount / 100);
      }
      this.planos = responsePlans.data;
    },
    async loadSubscription() {
      const responseSubs = await (
        await fetch(
          `${this.$menu_payment_uri}/api/users/subscriptions?start=1&limit=20`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "qrservice_token"
              )}`,
            },
          }
        )
      ).json();

      for (const item of responseSubs.data) {
        item.assinaturaPagarme.plan.amount = formatToBRL(
          item.assinaturaPagarme.plan.amount / 100
        );
        item.dtCriacao = formatToDate(new Date(item.dtCriacao));
        item.assinaturaPagarme.current_period_start = formatToDate(
          new Date(item.assinaturaPagarme.current_period_start)
        );
        item.assinaturaPagarme.current_period_end = formatToDate(
          new Date(item.assinaturaPagarme.current_period_end)
        );
        if (item.assinaturaPagarme.status === "trialing") {
          item.assinaturaPagarme.status = "Teste free";
        } else if (item.assinaturaPagarme.status === "paid") {
          item.assinaturaPagarme.status = "Pago";
        } else {
          item.assinaturaPagarme.status = "Desativado";
        }
      }
      this.pagamentos = responseSubs.data;
    },
    openDialog() {
      this.dialog = !this.dialog;
    },
    openLink(item) {
      const e = JSON.parse(localStorage.getItem("e"));

      var w = window.open(
        `${this.$menu_payment_link}/${item.idPlanoPagarme}?user=${
          e.idEstabelecimento
        }&token=${localStorage.getItem("qrservice_token")}`,
        "_blank"
      );
      w.focus();
    },
    async cancelSubscription() {
      const sub = this.pagamentos.find((item) => item.flAtivo === 1);
      try {
        const response = await (
          await fetch(
            `${this.$menu_payment_uri}/api/subscriptions/${sub.idAssinatura}/cancel`,
            {
              method: "PUT",
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "qrservice_token"
                )}`,
              },
            }
          )
        ).json();

        if (response.data && !response.data.errors) {
          this.$ons.notification.toast("Assinatura cancelada!", {
            timeout: 2000,
            animation: "ascend",
          });
        } else {
          this.$ons.notification.toast(
            "Ocorreu um erro ao tentar cancelar a assinatura!",
            {
              timeout: 3000,
              animation: "ascend",
            }
          );
        }
      } catch (error) {
        this.$ons.notification.toast(
          "Ocorreu um erro ao tentar cancelar a assinatura!",
          {
            timeout: 3000,
            animation: "ascend",
          }
        );
      }

      await this.loadSubscription();
      this.dialog = !this.dialog;
    },
  },
};
</script>
